import { render, staticRenderFns } from "./addPerusahaan.vue?vue&type=template&id=19f251a9&scoped=true&"
import script from "./addPerusahaan.vue?vue&type=script&lang=js&"
export * from "./addPerusahaan.vue?vue&type=script&lang=js&"
import style0 from "./addPerusahaan.vue?vue&type=style&index=0&id=19f251a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f251a9",
  null
  
)

export default component.exports